/* Pharos — disponibilité sur la fiche produit et l'aperçu rapide (19/10/2026).
   Lit les données du snippet pharos-dispo (métachamp de variante pharos.dispo, calculé par l'appli de gestion)
   et la quantité choisie dans le formulaire d'ajout au panier :
   - quantité couverte par le stock libre : « En stock » (mode exact) ou « Disponible » (mode prudent) ;
   - au-delà : délai supplémentaire, avec la semaine d'arrivée si une arrivée fournisseur datée la couvre ;
   - produit arrêté (fin de série) : pas de réapprovisionnement annoncé.
   - produit sur commande (armoires, packs, gammes, tag « sur-commande ») : toujours « Sur commande ».
   Mode : data-mode du snippet ; ?pharos_dispo=exact|prudent dans l'adresse pour tester.
   26/10/2026 (demande du projet SEO, décision de Simon) : « Expédié sous 24 h ouvrées », comme la page livraison
   et les CGV ; textes en néerlandais sur les pages /nl/ (langue lue sur <html lang>). */
(function () {
  var TEXTES = {
    fr: {
      mois: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
      enStock: "En stock",
      disponible: "Disponible",
      expedie: "Expédié sous 24 h ouvrées",
      arrivee: function (d) { return "arrivée prévue semaine du " + d; },
      delaiExact: "délai supplémentaire à prévoir",
      delaiPrudent: "délai supplémentaire probable",
      finDeSerie: "Fin de série",
      plusQueDispo: function (n) { return "Plus que " + n + " disponible" + (n > 1 ? "s" : "") + ", non réapprovisionné"; },
      quantiteLimitee: "Quantité limitée, non réapprovisionné",
      nonReappro: "Non réapprovisionné",
      plusQueStock: function (n) { return "Plus que " + n + " en stock"; },
      enPartie: "Disponible en partie",
      pourLeReste: function (delai, quand) { return "Pour le reste, " + delai + (quand ? " : " + quand : ""); },
      enReappro: "En réapprovisionnement",
      dansLaFoulee: ", expédition dans la foulée",
      surCommande: "Sur commande",
      surCommandeSub: "Préparé spécialement pour vous : délai supplémentaire à prévoir",
    },
    nl: {
      mois: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
      enStock: "Op voorraad",
      disponible: "Beschikbaar",
      expedie: "Verzonden binnen 24 werkuren",
      arrivee: function (d) { return "verwacht op voorraad in de week van " + d; },
      delaiExact: "reken op extra levertijd",
      delaiPrudent: "waarschijnlijk extra levertijd",
      finDeSerie: "Uitlopend artikel",
      plusQueDispo: function (n) { return "Nog " + n + " beschikbaar, wordt niet meer aangevuld"; },
      quantiteLimitee: "Beperkte hoeveelheid, wordt niet meer aangevuld",
      nonReappro: "Wordt niet meer aangevuld",
      plusQueStock: function (n) { return "Nog " + n + " op voorraad"; },
      enPartie: "Gedeeltelijk beschikbaar",
      pourLeReste: function (delai, quand) { return "Voor de rest: " + delai + (quand ? ", " + quand : ""); },
      enReappro: "Wordt aangevuld",
      dansLaFoulee: ", daarna direct verzonden",
      surCommande: "Op bestelling",
      surCommandeSub: "Speciaal voor u klaargemaakt: reken op extra levertijd",
    },
  };
  function langue() {
    var l = "";
    try { l = (document.documentElement.getAttribute("lang") || (window.Shopify && window.Shopify.locale) || "").toLowerCase(); } catch (e) { l = ""; }
    return l.indexOf("nl") === 0 ? "nl" : "fr";
  }
  var T = TEXTES[langue()];
  function jourMois(iso) {
    var p = String(iso).split("-");
    return parseInt(p[2], 10) + " " + T.mois[parseInt(p[1], 10) - 1];
  }
  function majuscule(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  var forced = (function () {
    try { var m = new URLSearchParams(window.location.search).get("pharos_dispo"); return m === "exact" || m === "prudent" ? m : null; } catch (e) { return null; }
  })();

  function compute(d, qty, mode) {
    var exact = mode === "exact";
    var libre = Math.max(0, d.libre || 0);
    var reste = qty - libre;
    if (reste <= 0) return { cls: "ok", main: exact ? T.enStock : T.disponible, sub: T.expedie };
    // arrivées fournisseur encore libres, dans l'ordre : la semaine qui couvre le reste demandé
    var semaine = null, need = reste, arr = d.arrivees || [];
    for (var i = 0; i < arr.length && need > 0; i++) { need -= arr[i].q; semaine = arr[i].s; }
    if (need > 0) semaine = null;
    var quand = semaine ? T.arrivee(jourMois(semaine)) : null;
    var delai = exact ? T.delaiExact : T.delaiPrudent;
    if (d.fin && !semaine) {
      return { cls: "warn", main: T.finDeSerie, sub: libre > 0 ? (exact ? T.plusQueDispo(libre) : T.quantiteLimitee) : T.nonReappro };
    }
    if (libre > 0) {
      return { cls: "warn", main: exact ? T.plusQueStock(libre) : T.enPartie, sub: T.pourLeReste(delai, quand) };
    }
    return { cls: "warn", main: T.enReappro, sub: quand ? majuscule(quand) + T.dansLaFoulee : majuscule(delai) };
  }

  function init(box) {
    if (box.__pharosDispo) return;
    box.__pharosDispo = true;
    var data = {};
    try { data = JSON.parse(box.querySelector('script[type="application/json"]').textContent) || {}; } catch (e) { data = {}; }
    var mode = forced || box.getAttribute("data-mode") || "prudent";
    var surCommande = box.getAttribute("data-sur-commande") === "1";
    var scope = box.closest(".shopify-section, [data-section-id], .quick-view, section") || document;
    var line = box.querySelector(".pharos-dispo__line");
    var main = box.querySelector(".pharos-dispo__main");
    var sub = box.querySelector(".pharos-dispo__sub");
    var last = "";
    function current() {
      var form = scope.querySelector('form[action*="/cart/add"]');
      var idInput = form && form.querySelector('[name="id"]');
      var qtyInput = scope.querySelector('input[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return { id: String(idInput && idInput.value ? idInput.value : box.getAttribute("data-selected")), qty: Math.max(1, isNaN(qty) ? 1 : qty) };
    }
    function render() {
      if (!document.documentElement.contains(box)) { clearInterval(timer); return; }
      var c = current();
      var key = c.id + ":" + c.qty;
      if (key === last) return;
      last = key;
      var d = data[c.id];
      if (!d && !surCommande) { line.hidden = true; return; }
      var r = surCommande
        ? { cls: "warn", main: T.surCommande, sub: T.surCommandeSub }
        : compute(d, c.qty, mode);
      line.className = "pharos-dispo__line is-" + r.cls;
      main.textContent = r.main;
      sub.textContent = r.sub || "";
      line.hidden = false;
    }
    // les boutons +/- et le choix de variante ne déclenchent pas toujours d'événement : on relit 3 fois par seconde
    var timer = setInterval(render, 350);
    render();
  }

  function scan(root) {
    var list = (root || document).querySelectorAll ? (root || document).querySelectorAll("[data-pharos-dispo]") : [];
    for (var i = 0; i < list.length; i++) init(list[i]);
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches("[data-pharos-dispo]")) init(n); else scan(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { scan(); }); else scan();
})();
